export enum PrerequisiteState {
  PrerequisiteStart = 'PrerequisiteStart',
  Prepared = 'Prepared',
  CollectingData = 'CollectingData',
  Validating = 'Validating',
  Retry = 'Retry',
  Fulfilled = 'Fulfilled',
  Error = 'Error',
}
